// What tells a screen reader the editable area is invalid and where its message is. The server
// renders them on a refused save. TinyMCE's remove() puts the element's attributes back to what they
// were when the editor started, so a morph that adds them to a live editor loses them again when the
// controller tears the editor down. The controller reads them before the teardown and puts them back.
const INVALID_MARKING_ATTRIBUTES = ["aria-invalid", "aria-describedby"];

export type InvalidMarking = ReadonlyArray<readonly [name: string, value: string | null]>;

export function captureInvalidMarking(editable: HTMLElement | null): InvalidMarking {
    if (!editable) return [];
    return INVALID_MARKING_ATTRIBUTES.map((name) => [name, editable.getAttribute(name)] as const);
}

export function restoreInvalidMarking(editable: HTMLElement | null, marking: InvalidMarking): void {
    if (!editable) return;
    for (const [name, value] of marking) {
        if (value === null) {
            editable.removeAttribute(name);
        } else {
            editable.setAttribute(name, value);
        }
    }
}
